export default function IconSeasons() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="7" width="28" height="1" rx="0.5" fill="currentColor" />
      <rect x="4" y="4" width="24" height="1" rx="0.5" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M1 10C0.447715 10 0 10.4477 0 11V27C0 27.5523 0.447715 28 1 28H31C31.5523 28 32 27.5523 32 27V11C32 10.4477 31.5523 10 31 10H1ZM13 22.0672C13 22.8984 13.6084 23.2373 14.3588 22.8236L19.937 19.749C20.6877 19.3352 20.6877 18.6647 19.937 18.2509L14.3588 15.1762C13.6084 14.7629 13 15.1014 13 15.9334L13 22.0672Z"
        fill="currentColor" />
    </svg>

  );
}
